module.exports = __webpack_public_path__ + "img/user.b5bc0253.svg";